import { neighborhoodCrudConfig, type Neighborhood } from '@/config/objects/neighborhoods';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Neighborhood create/edit form page
 */
export function NeighborhoodFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // If id is 'new', treat as create mode (id = undefined)
  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  /**
   * Handle successful form submission
   */
  const handleSuccess = (neighborhood: Neighborhood) => {
    // Navigate to the neighborhood detail page
    navigate(`/neighborhoods/${neighborhood.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Neighborhoods', href: '/neighborhoods' },
        { label: 'Neighborhood', href: `/neighborhoods/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Neighborhoods', href: '/neighborhoods' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={neighborhoodCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
